import React, { useRef } from 'react';
import { Box } from '@mui/material';
import ReadMore from '@/components/ReadMore';
import ShowMoreCollapse from '@/components/ShowMoreCollapse';

export default function CollapseBoxHtml({
  html,
  variant = 'read-more',
  minSize = 26,
  starClose = false,
  onChange,
}) {
  const itemRef = useRef(null);
  const body = (
    <Box
      ref={itemRef}
      sx={{
        'fontSize': '14px',
        '& ul': {
          ml: 3,
        },
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: html }}></div>
    </Box>
  );
  if (variant === 'show-more') {
    return <ShowMoreCollapse onChange={onChange}>{body}</ShowMoreCollapse>;
  }
  return (
    <ReadMore
      onChange={onChange}
      childrenRef={itemRef}
      minSize={minSize}
      starClose={starClose}
    >
      {body}
    </ReadMore>
  );
}

CollapseBoxHtml.defaultProps = {
  onChange: () => {},
};
